"use client";
import Link from "next/link";
import { routing } from "@/i18n/routing";
// import posthog from "posthog-js";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // useEffect(() => {
  //   // Log to reporting service in production
  //   console.error("Application error:", error);
  //   // Capture the error in PostHog for Error Tracking
  //   posthog.captureException(error, {
  //     error_boundary_triggered: true,
  //     error_digest: error.digest,
  //   });
  //   posthog.capture("error_boundary_triggered", {
  //     error_message: error.message,
  //     error_digest: error.digest,
  //   });
  // }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="text-center">
        <h1 className="mb-2 text-6xl font-bold text-destructive sm:text-8xl">
          Error
        </h1>
        <h2 className="mb-4 text-xl font-semibold text-foreground sm:text-2xl">
          Something went wrong
        </h2>
        <p className="mb-8 max-w-md text-muted-foreground">
          An unexpected error occurred. Please try again or return to the home
          page.
        </p>
        <div className="flex flex-col gap-4 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={reset}
            className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            Try again
          </button>
          <Link
            href={`/${routing.defaultLocale}`}
            className="inline-flex items-center justify-center rounded-md border border-input bg-background px-6 py-3 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
